/* global axios */
/* CUSTOM: bocket-evolution-signature-toggle — BKT-015 */
import ApiClient from '../ApiClient';

class BocketEvolutionSignatureAPI extends ApiClient {
  constructor() {
    super('bocket/evolution_signature', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(senderNameEnabled) {
    return axios.patch(this.url, { sender_name_enabled: senderNameEnabled });
  }
}

export default new BocketEvolutionSignatureAPI();
